import userService from "../services/userService";
import fileService from "../services/fileService.js";
import Roles from "../models/Roles.js";
import File from "../models/File.js";

export const file = {
  namespaced: true,
  state: {
    sharedCount: 0,
    mineCount: 0
  },
  actions: {
    count({commit}) {
      commit('clear');
      if (userService.isLogged() && userService.getMyRole() === Roles.client) {
        fileService.getFiles(File.Origins.shared)
          .then(
            files => commit('newSharedCount', files.filter(file => !file.read).length),
            error => commit('newSharedCount', 0)
          );
        fileService.getFiles(File.Origins.mine)
          .then(
            files => commit('newMineCount', files.filter(file => !file.read).length),
            error => commit('newMineCount', 0)
          );
      }
    }
  },
  mutations: {
    newSharedCount(state, count) {
      state.sharedCount = count;
    },
    newMineCount(state, count) {
      state.mineCount = count;
    },
    clear(state) {
      state.sharedCount = 0;
      state.mineCount = 0;
    }
  }
};



// WEBPACK FOOTER //
// ./src/store/file.module.js